export default {
  title: '示例（繁体）',
  rule: {
    title: '免責聲明',
    label: '謹此聲明本人參加本活動，並願意遵守由主辦機構所訂的條文及規則，以及同意以下所列各點：',
    content: ['本人是自願參加此活動和願意承擔自身的意外風險及責任，並無權向主辦機構對本人往返活動場地途中、活動中發生或引致之自身意外、死亡或任何形式的損失提出索償或追討責任。',
      '本人聲明本人身體情況良好及有能力參加此活動，及沒有執業醫生曾提出相反意見。',
      '本人願意接受主辦機構要求及提供的藥物檢查及治療。',
      '本人於活動當天（2019年2月17日）已經符合參加組別之最低年齡規定（如參加者未年滿18歲，須由其家長或監護人簽署同意聲明）。',
      '本人明白及同意本人的個人資料將轉交予主辦機構用作活動安排之用途。',
      '本人證實已事先獲得同行參加者及/或緊急聯繫人的同意，可使用其個人資料於本活動的報名表格作報名及/或緊急聯繫用途。',
      '本人願意授權予及同意主辦機構及傳媒在不需要審查情況及不需要本人另外同意下而可使用本人的個人資料、肖像、姓名及聲線作為籌辦及推廣活動之用，包括本人肖像及姓名有可能被使用於主辦機構有關本活動之網頁、短片及刊物。',
      '本人提交確認即表示同意及確認所有列明之「參加者須知及條款細則」、「免責聲明」及「個人資料收集聲明」，以及所有不時於活動指定宣傳渠道更新的任何更改。'
    ]
  }
}


// WEBPACK FOOTER //
// ./src/locale/demo/zh-hk.js